var $3ba5d3f7470acf48$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    setTimeout($3ba5d3f7470acf48$var$iniciarC, 2500);
});
document.addEventListener("scroll", $3ba5d3f7470acf48$var$initOnEvent);
document.addEventListener("mousemove", $3ba5d3f7470acf48$var$initOnEvent);
document.addEventListener("touchstart", $3ba5d3f7470acf48$var$initOnEvent);
function $3ba5d3f7470acf48$var$initOnEvent(event) {
    $3ba5d3f7470acf48$var$iniciarC();
    event.currentTarget.removeEventListener(event.type, $3ba5d3f7470acf48$var$initOnEvent); // remove the event listener that got triggered
}
async function $3ba5d3f7470acf48$var$iniciarC() {
    $3ba5d3f7470acf48$var$initCountDown();
}
// add this before event code to all pages where PII data postback is expected and appropriate
function $3ba5d3f7470acf48$var$initCountDown() {
    // Set the date we're counting down to
    var countDownDate = new Date("06/11/2025 19:00:00").getTime();
    // Update the count down every 1 second
    var x = setInterval(function() {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / 86400000);
        var hours = Math.floor(distance % 86400000 / 3600000);
        var minutes = Math.floor(distance % 3600000 / 60000);
        var seconds = Math.floor(distance % 60000 / 1000);
        // If the count down is finished, write some text
        if (distance < 0) clearInterval(x);
        else // Display the result in the element with id="demo"
        document.getElementById("count").innerHTML = `
          <div class="count-item">
            <span class="numero-count">${days}</span>
            <span class="numero-count-label">Dias</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${hours}</span>
            <span class="numero-count-label">Horas</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${minutes}</span>
            <span class="numero-count-label">Minutos</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${seconds}</span>
            <span class="numero-count-label">Segundos</span>
          </div>
        `;
    }, 1000);
}


//# sourceMappingURL=index.6f2194e7.js.map
